<template>
<svg viewBox="0 0 26 26" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Metope`]" width="1em" height="1em" v-bind="$attrs"><path d="M9.75336 23.2537C9.20108 23.2537 8.75337 22.806 8.75337 22.2538V18.5741H3C2.44771 18.5741 2 18.1264 2 17.5741V13.3323C2 12.78 2.44772 12.3323 3 12.3323H8.75337V9.24195H3C2.44771 9.24195 2 8.79424 2 8.24195V4C2 3.44772 2.44772 3 3 3H16.3745C16.9268 3 17.3745 3.4477 17.3745 3.99997L17.3746 7.67948H23.1278C23.6801 7.67948 24.1278 8.1272 24.1278 8.67948V12.9214C24.1278 13.4737 23.6801 13.9214 23.1278 13.9214H17.3746V17.0118H23.1278C23.6801 17.0118 24.1278 17.4595 24.1278 18.0118V22.2539C24.1278 22.8062 23.6801 23.2539 23.1278 23.2539L9.75336 23.2537ZM22.5384 21.6644V18.6012H10.3428V21.6644H22.5384ZM15.7851 16.9849V13.9217H3.58938V16.9849H15.7851ZM22.5384 12.3321V9.26886H10.3428V12.3321H22.5384ZM15.7851 7.65257V4.58938H3.58938V7.65257H15.7851Z"/></svg>
</template>
<script>

export default {
  name: 'IconMetope',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
